import { StyleSheet, Dimensions } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        backgroundColor: 'white',
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
        marginTop: 12,
    },
    brand: {
        width: 120,
        height: 120,
        alignSelf: 'center',
    },
    brandProduct: {
        fontSize: 14,
        fontWeight: '500',
        color: theme.colors.textSecondary,
        marginTop: 12,
        marginHorizontal: 12,
    },
    nameProduct: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        marginHorizontal: 12,
        marginTop: 4,
        marginBottom: 8,
        textAlignVertical: 'top',
    },
    descriptionProduct: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 10,
        marginHorizontal: 12,
    },
    containerDataProduct: {
        flexDirection: 'row',
        paddingHorizontal: 12,
    },
    dataProduct: {
        flex: 1,
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        marginBottom: 2,
    },
    dividerHorizontalLine: {
        height: StyleSheet.hairlineWidth,
        backgroundColor: theme.colors.textSecondary,
        marginHorizontal: 12,
        marginVertical: 6,
        flex: 1,
    },
    containerItem: {
        marginHorizontal: 12,
        marginVertical: 0,
        flexDirection: 'row',
        alignItems: 'center',
        paddingVertical: 10,
        borderBottomWidth: 0,
        borderBottomColor: theme.colors.textSecondary,
        borderRadius: 0,
        backgroundColor: 'white',
    },
    fileName: {
        flex: 1,
        fontSize: 14,
        color: theme.colors.darkGray,
        fontWeight: 'normal',
    },
    icons: {
        flexDirection: 'row',
    },
    iconButton: {
        height: 24,
        width: 24,
        marginLeft: 10,
        tintColor: theme.colors.colorPrimary,
    },
    spacer: {
        marginBottom: 0,
    },
})
export default styles
